import { DialogContentProps, default as MuiDialogContent } from '@mui/material/DialogContent'
import * as React from 'react'

const DialogContent: React.FC<React.PropsWithChildren<DialogContentProps>> = (props) => <MuiDialogContent {...props} />

export default DialogContent
